/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetTenantSettingsResponseJson } from './get-tenant-settings-response-json';
import { GetTenantSettingsResult } from '../results/get-tenant-settings-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { DelegateType } from '../enums/delegate-type.enum';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetTenantSettingsResponse extends ResponseWithErrorGeneric<GetTenantSettingsResponseJson, GetTenantSettingsResult> implements IResponseWithErrorGeneric<GetTenantSettingsResult> {
  public name: string = undefined;
  public receiver: string = undefined;
  public sender: string = undefined;
  public defaultDelegateType: DelegateType;
  public defaultDelegateId: number = undefined;
  public defaultLocale: string = undefined;
  public defaultNorwegianDeclarantId: string = undefined;
  public defaultSwedishDeclarantId: string = undefined;

  //<custom-body>
  constructor(response: HttpResponse<GetTenantSettingsResponse>) {
    super(response, GetTenantSettingsResult.Error);
    if (this.result !== GetTenantSettingsResult.Success) {
      return;
    }

    Object.assign(this, response.body);
  }
  //</custom-body>
}
